
import React, { Fragment, createRef, useState } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import { IMaskInput } from 'react-imask';
import { useDispatch, useSelector } from "react-redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import ApartmentIcon from '@mui/icons-material/Apartment';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';

import { setFormDataAction } from 'redux/actions/getFormActions';

const PhoneMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(+44) 000 000 0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

PhoneMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Form1 = (props) => {
    const dispatch = useDispatch();
    const formData = useSelector(state => state.formData.data);

    const handleChange = (e, label) => {
      if(label === 'email') {
        const value = e.target.value;
        dispatch(setFormDataAction({...formData, [label]:value, [label+'_valid']:validator.isEmail(value)}));
      } else if (label === 'phone') {
        let value = e.target.value;
        if(value[6] === '0') {
          value = value.slice(0, 5) + value.slice(7);
        }
        dispatch(setFormDataAction({...formData, [label]:value, phone_valid: (value.length === 18 ? true : false) }));
      } else if(label === 'buildingNumber' || label === 'unitsNumber') {
        const value = e.target.value;
        dispatch(setFormDataAction({...formData, [label]:value, [label+'_valid']:validator.isNumeric(value)}));
      } else {
        const value = e.target.value;
        dispatch(setFormDataAction({...formData, [label]:value}));
      }
    };

  const disable = 
    (formData.buildingNumber && formData.firstName && formData.lastName && formData.orgName && (!formData.unitsNumber || formData.unitsNumber_valid)
      && formData.email && formData.phone && formData.buildingNumber_valid && formData.email_valid && formData.phone_valid ) ? false : true;

  return (
    <Fragment>
        {formData.success && formData.success.status === 'success' && 
          <Typography color="primary" variant="body1" align='center' sx={{mt:2}}>      
            LandlordId: {formData.success.value}
          </Typography>
        } 
        <Grid container justifyContent='center' sx={{ my: 1 }} spacing={1}>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt:2, mr:1}}>
                <AccountCircle sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">First Name</Typography>
                <TextField
                    error={!formData.firstName}
                    variant="standard"
                    color={formData.firstName ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.firstName}
                    onChange={(e) => handleChange(e, 'firstName')} 
                    />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt:2, mr:1}}>
                <AccountCircle sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">Last Name</Typography>
                <TextField
                    error={!formData.lastName}
                    variant="standard"
                    color={formData.lastName ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.lastName}
                    onChange={(e) => handleChange(e, 'lastName')} 
                    />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt:2, mr:1}}>
                <CorporateFareIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">Organisation Name</Typography>
                <TextField
                    error={!formData.orgName}
                    variant="standard"
                    color={formData.orgName ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.orgName}
                    onChange={(e) => handleChange(e, 'orgName')} 
                    />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={2} sx={{mt:2, mr:1}}>
                  <MarkunreadIcon sx={{fontSize: 37 }} color="primary"/>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">Email</Typography>
                  <TextField
                      error={!formData.email || !formData.email_valid}
                      variant="standard"
                      color={formData.email ? "primary" : "error"}
                      required
                      fullWidth
                      value={formData.email}
                      onChange={(e) => handleChange(e, 'email')} 
                      />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                <PhoneIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                  <Typography variant="body2" color="primary">Phone Number</Typography>
                  {/* <MuiPhoneNumber 
                    defaultCountry={'gb'} 
                    fullWidth
                    onChange={(e) => handleChange(e, 'phone')}
                    inputProps={{required: true}}
                    color={formData.phone ? "primary" : "error"}
                  /> */}
                  <TextField
                      error={!formData.phone_valid || !formData.phone}
                      variant="standard"
                      required
                      fullWidth
                      value={formData.phone}
                      onChange={(e) => handleChange(e, 'phone')}
                      InputProps={{
                        inputComponent: PhoneMaskCustom
                      }}
                  />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={2} sx={{mt:2, mr:1}}>
                  <ApartmentIcon sx={{fontSize: 37 }} color="primary"/>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">Number of Buildings</Typography>
                  <TextField
                      error={!formData.buildingNumber || !formData.buildingNumber_valid}
                      variant="standard"
                      color={formData.buildingNumber ? "primary" : "error"}
                      required
                      fullWidth
                      helperText={formData.buildingNumber && !formData.buildingNumber_valid ? 'Please enter a valid number' : ''}
                      value={formData.buildingNumber}
                      onChange={(e) => handleChange(e, 'buildingNumber')} 
                      />
                </Grid>
              </Grid>
          </Grid>
          <Grid item xs={11} sm={10} md={7}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={2} sx={{p:1, mt:2, mr:1}}>
                  <NightShelterIcon sx={{fontSize: 37 }} color="primary"/>
                </Grid>
                <Grid item xs={9}> 
                    <Typography variant="body2" color="primary">Number of Units</Typography>
                    <TextField
                        error={!formData.unitsNumber_valid}
                        variant="standard"
                        color={formData.unitsNumber ? "primary" : "error"}
                        required
                        fullWidth
                        helperText={formData.unitsNumber && !formData.unitsNumber_valid ? 'Please enter a valid number' : ''}
                        value={formData.unitsNumber}
                        onChange={(e) => handleChange(e, 'unitsNumber')}
                    />
                </Grid>
              </Grid>
          </Grid>
        </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', my: 3 }}>
              <Button 
                onClick={() => props.handleNext()} 
                variant="contained" 
                disabled={disable}
              >
                  <Typography> Next </Typography>
              </Button>
          </Box>
    </Fragment>
  );
}
  
export default Form1;
